// The dollars and boot flag the pay page is showing. The server charges
// only when the locked ticket still matches this quote. `amount` on the
// payment post stays the fine; a boot charge adds the hold on the server.
export function paymentQuote(violation) {
  const requiresBoot = !(violation && violation.requires_boot === false);
  const fine = Number(violation && violation.amount);
  const hold = Number(violation && violation.hold_amount);
  const puc = Boolean(violation && violation.has_approved_puc_form);
  const total = !requiresBoot || puc ? fine : fine + hold;
  return {
    requires_boot: requiresBoot,
    quoted_total: total,
  };
}

export function paymentButtonLabel(violation) {
  const quote = paymentQuote(violation);
  const dollars = Number(quote.quoted_total).toFixed(2);
  if (!quote.requires_boot) {
    return `Pay fine $${dollars}`;
  }
  return `Unlock Boot for $${dollars}`;
}
